export default "__VITE_ASSET__f0ab4b46__"